import React from 'react';

const TrophyIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M10 6h12v10a6 6 0 0 1-12 0V6Z" fill="#F5C518"/>
        <path d="M7 8H10v6a3 3 0 0 1-3-3V8Z" fill="#FFD740" opacity="0.6"/>
        <path d="M22 8h3v3a3 3 0 0 1-3 3V8Z" fill="#FFD740" opacity="0.6"/>
        <rect x="14" y="22" width="4" height="4" fill="#F5C518"/>
        <rect x="10" y="26" width="12" height="2.5" rx="1.25" fill="#c9a012"/>
        <circle cx="16" cy="13" r="3" fill="#fff" opacity="0.4"/>
    </svg>
);

export default TrophyIcon;